module.exports = __webpack_public_path__ + "static/vascular-85569f061be370fc34e4e255a6426de4.png";